import Clarity from '@microsoft/clarity'

/**
 * @param {object} event
 * @param {object} event.experiment
 */
export function trackExperimentSetEvent({ experiment }) {
  const { code, id } = experiment

  Clarity.setTag(id, code)
  Clarity.event(formatEventName(`experiment_${id}`))
  Clarity.upgrade('experiment')
}

/**
 * @param {string} eventName
 * @returns {string}
 */
export function formatEventName(eventName) {
  return eventName.toLowerCase().replace(/-/g, '_')
}
